import {Component, OnInit} from '@angular/core';
import GameConfig = Phaser.Types.Core.GameConfig;

import * as Phaser from 'phaser';
import {MainScene} from './MainScene';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  //   const config: GameConfig = {
  //     type: Phaser.CANVAS,
  //     title: 'Template Game 3.0',
  //     backgroundColor: '#dedede',
  //     banner: false,
  //     scale: {
  //       parent: 'phaser-div',
  //       mode: Phaser.Scale.HEIGHT_CONTROLS_WIDTH,
  //     },
  //   };
  //   const game = new Phaser.Game(config);
  //   game.scene.add('main', MainScene, true);
  }
}


